module.exports = __webpack_public_path__ + "img/benoit10.6308e37e.jpg";